import {getMostDamagingAttack} from '../../analysis/action-analysis-utilities.js'

export function getViciousPath(casterModel, teamCombatants=[], enemyCombatants=[], casterActions=[]) {

  const aliveTargets = enemyCombatants.filter(combModel => combModel.hp > 0);
  const lowestHpEnemy = aliveTargets.sort((a,b) => {
    return a.hp > b.hp ? 1 : -1
  })[0];

  const action = getMostDamagingAttack(casterActions);

  //console.log('vicious path', action.name)



  return {
    actionModel: action,
    casterModel: casterModel,
    //Honor the targetType of the selected action (Honeypot Trap)
    //targetModels: action.targetType === "only-me" ? [casterModel] : [lowestHpEnemy]
    targetModels: getViciousPathTarget(action, casterModel, aliveTargets, lowestHpEnemy)
  };

}

//There are a few odd cases for the targeting, so extracting the target picking this to a cleaner function:
function getViciousPathTarget(action, casterModel, aliveTargets, lowestHpEnemy) {

  //If this affects only me (wouldn't expect this to happen in Vicious, but who knows?)
  if (action.targetType === "only-me") {
    return [casterModel]
  }

  //We target the whole team, so return all alive targets
  if (action.targetType === "opponent-team") {
    return aliveTargets
  }

  //Default to picking the lowest enemy
  return [lowestHpEnemy];
}



// VICIOUS
// - Identify the lowest HP enemy
// - Strike with attack (should this be the highest damaging attack?)


// WEBPACK FOOTER //
// ./src/battle/bot-decisions/personality-paths/get-vicious-path.js